import { Pagination, SuccessResponse } from "common/common.interface";
import { environment } from "common/environment";
import { DevisFilter } from "modules/devis/types/devis.interface";
import {
  Invoice,
  CreateInvoicePayload,
  Statistic,
} from "modules/invoice/types/invoice.interface";

export interface invoiceBackend {
  getInvoices(
    page: number,
    limit: number,
    searchName: string | undefined,
    filters?: DevisFilter
  ): Promise<Pagination<Invoice>>;
  getInvoice(id: string): Promise<Invoice>;
  createInvoice(
    workspaceId: string,
    payload: CreateInvoicePayload,
    commandeId: string | undefined
  ): Promise<Invoice>;
  updateInvoice(id: string, payload: CreateInvoicePayload): Promise<Invoice>;
  archiveInvoice(id: string): Promise<SuccessResponse>;
  downloadInvoice(id: string): Promise<ArrayBuffer>;
  getStatistic(startDate?: string, endDate?: string): Promise<Statistic>;
  getOnHold(
    page: number,
    limit: number,
    searchName: string | undefined,
    filters?: DevisFilter
  ): Promise<Pagination<Invoice>>;
  getLate(
    page: number,
    limit: number,
    searchName: string | undefined,
    filters?: DevisFilter
  ): Promise<Pagination<Invoice>>;
}

let invoiceBackendInstance: invoiceBackend | undefined;

export async function getInvoiceBackend(): Promise<invoiceBackend> {
  if (invoiceBackendInstance === undefined) {
    const mod = await import(`./${environment.ARTICLE_BACKEND}`);
    invoiceBackendInstance = new mod.default() as invoiceBackend;
  }
  return invoiceBackendInstance;
}
